import { useMutation } from "react-query";
import { submitToAcumatica } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useSubmitToAcumatica = () => {
  return useMutation(submitToAcumatica);
};
export default useSubmitToAcumatica;
